import { useMutation, useQuery } from "@tanstack/react-query";
import { getReviewDetail, getReviewList, getReviewResultDetail, getReviewResultList, getReviewReviewee, modifyReview, postReview, putReviewActive } from "./service";

/**
 * review
 */

export const useReviewList = (pageNum, count) =>
    useQuery({
        queryKey: ["reviewlist", pageNum, count],
        queryFn: () => getReviewList(pageNum, count),
    });

export const useReviewDetail = (idx, userIdx) =>
    useQuery({
        queryKey: ["reviewdetail", idx, userIdx],
        queryFn: () => getReviewDetail(idx, userIdx),
        enabled: !!userIdx,
    });

export const useReviewData = (idx) =>
    useQuery({
        queryKey: ["reviewdata", idx],
        queryFn: () => getReviewReviewee(idx),
    });

export const useReviewReviewee = (idx) =>
    useQuery({
        queryKey: ["reviewreviewee", idx],
        queryFn: () => getReviewReviewee(idx),
    });

export const useReviewSubmit = () => {
    return useMutation({
        mutationKey: ["reviewsubmit"],
        mutationFn: async (data) => {
            return await postReview(data.reviewIdx, data.revieweeIdx, data.data);
        }
    });
};

export const useReviewSubmitModify = () => {
    return useMutation({
        mutationKey: ["reviewsubmitmodify"],
        mutationFn: async (data) => {
            return await modifyReview(data.reviewIdx, data.revieweeIdx, data.data);
        }
    });
};

export const useReviewResultList = (pageNum, count) =>
    useQuery({
        queryKey: ["reviewresultlist", pageNum, count],
        queryFn: () => getReviewResultList(pageNum, count),
    });

export const useReviewResultDetail = (reviewIdx) =>
    useQuery({
        queryKey: ["reviewresultdetail", reviewIdx],
        queryFn: () => getReviewResultDetail(reviewIdx),
    });

export const useReviewActive = () => {
    return useMutation({
        mutationKey: ["reviewactive"],
        mutationFn: async (data) => {
            return await putReviewActive(data.reviewIdx, data.revieweeIdx, data.isActive);
        }
    });
};
